import React from 'react';
import {Button, Group, Box, Grid, Textarea, Select} from '@mantine/core';
import {useForm} from '@mantine/form';
import {ArrowRight} from "tabler-icons-react";


interface Props {
    onSubmitQuery?: (query: any) => void,
    initialValues?: any
}

interface FormValues {
    agentStatus: string,
    comments: string
}

function AgentReview({onSubmitQuery, initialValues}: Props) {
    const form = useForm<FormValues>({
        initialValues: initialValues || {
            agentStatus:"",
            comments: ""
        },
        validate: {
        },
    });

    function onSubmit(values: typeof form.values) {
        if (onSubmitQuery){
            onSubmitQuery(values)
        }
    }

    return (
        <div className='agent-filters'>
            <Box mx="auto">
                <form onSubmit={form.onSubmit(onSubmit)}>
                    <Grid>
                        <Grid.Col sm={12}>
                            <Textarea
                                label="Comments"
                                placeholder="Comments"
                                minRows={3}
                                {...form.getInputProps('comments')}
                            />
                        </Grid.Col>
                        <Grid.Col sm={12}>
                            <Select
                                label="Set New Agent Status"
                                placeholder="Agent Status"
                                clearable
                                searchable
                                required
                                data={[
                                    { value: 'Approved', label: 'Approved' },
                                    { value: 'Denied', label: 'Denied' },
                                    { value: 'Pending Review', label: 'Pending Review' },
                                ]}
                                {...form.getInputProps('agentStatus')}
                            />
                            <Group position="right" mt="md">
                                <Button type="submit" rightIcon={<ArrowRight/>}>Edit Agent</Button>
                            </Group>
                        </Grid.Col>
                    </Grid>
                </form>
            </Box>
        </div>
    )
}

export default AgentReview;